import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Server, Database, Wifi, ShieldCheck } from "lucide-react";

const services = [
  { name: "API Gateway", detail: "FastAPI · uvicorn", status: "healthy", icon: Server },
  { name: "MongoDB", detail: "Motor async driver", status: "healthy", icon: Database },
  { name: "Payments (Stripe)", detail: "Claimable sandbox · Test", status: "healthy", icon: ShieldCheck },
  { name: "AI (Claude Sonnet 4.5)", detail: "via Emergent LLM Key", status: "healthy", icon: Wifi },
];

export default function InfrastructurePage() {
  return (
    <div>
      <PageHeader eyebrow="Admin Tools" title="Infrastructure" subtitle="Service health snapshot." />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {services.map((s) => (
          <Card key={s.name} className="border-white/10 bg-card p-5 flex items-start gap-3">
            <div className="h-10 w-10 rounded-md bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
              <s.icon className="h-5 w-5 text-emerald-400" />
            </div>
            <div className="flex-1">
              <div className="font-medium">{s.name}</div>
              <div className="text-xs text-zinc-500">{s.detail}</div>
            </div>
            <div className="text-xs uppercase tracking-widest text-emerald-400 font-medium">{s.status}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
